<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a><a id="cont"></a><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/author#author">An Appreciation<br/><span class="small">BY RICHARD FORD</span></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">Water Liars</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch02#ch02">Love Too Long</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch03#ch03">Testimony of Pilot</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Coming Close to Donna</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Dragged Fighting from His Tomb</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Quo Vadis, Smut?</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Return to Return</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Green Gets It</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Midnight and I’m Not Famous Yet</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Our Secret Home</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Eating Wife and Friends</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">All the Old Harkening Faces at the Rail</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Knowing He Was Not My Kind Yet I Followed</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">That’s True</span></p>
<p class="tocchap"><a id="page_viii"></a><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">Escape to Newark</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Pete Resists the Man of His Old Room</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">Behold the Husband in His Perfect Agony</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">Constant Pain in Tuscaloosa</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch19#ch19" title="Link target outside of Sample">Deaf and Dumb</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch20#ch20" title="Link target outside of Sample">Mother Rooney Unscrolls the Hurt</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6b19809e